import { AllowChangeGrid } from '../../../services/modules/product-colors-packs/product-colors-packs.types';
import { AvailabilityEnum } from '../../products/ProductTypes';

export const packDisallowChange = (
  availability: AvailabilityEnum,
  allowChangePreOrderGrid?: AllowChangeGrid,
  allowChangeImmediateGrid?: AllowChangeGrid,
) => {
  const disallowChangePreOrderGrid = allowChangePreOrderGrid === AllowChangeGrid.DISALLOW;
  const disallowChangeImmediateGrid = allowChangeImmediateGrid === AllowChangeGrid.DISALLOW;

  switch (availability) {
    case AvailabilityEnum.INFINITE_PRE_ORDER:
    case AvailabilityEnum.FUTURE_STOCK:
    case AvailabilityEnum.MATERIAL_PRE_ORDER:
      return disallowChangePreOrderGrid;
    case AvailabilityEnum.READY_FOR_DELIVERY:
      return disallowChangeImmediateGrid;
    case AvailabilityEnum.EMPTY:
      return disallowChangePreOrderGrid || disallowChangeImmediateGrid;
    default:
      return true;
  }
};
